/** @jsx jsx */
// import React from 'react';
// import ReactDOM from 'react-dom';
import { css, jsx } from '@emotion/core';
import {
  useState,
  useRef,
  useEffect,
  createContext,
  useContext,
  useMemo,
  Fragment as _,
  cloneElement,
} from 'react';
import Drag_Icon_Blue from 'assets/Drag Icon_Blue.svg';
import Resize_Icon from 'assets/Resize Icon.svg';
import move_cert_input from 'assets/move_cert_input.svg';
import resize_cert_input from 'assets/resize_cert_input.svg';

const handleSize = 16;

const DragHandle = props => {
  const {
    id,
    elementRef,
    cursor = 'move',
    inverseScaleFactor = 1,
    onDragEnd = () => {},
    isInput = false,
  } = props;

  if (!window.dev()) {
    return null;
  }

  return (
    <div
      id={`chameleon-text-drag-handle-${id}`}
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: handleSize,
        height: handleSize,
        ...(inverseScaleFactor > 1 && {
          transform: `scale(${inverseScaleFactor})`,
          transformOrigin: 'top left',
        }),
        background: `url('${
          !isInput ? Drag_Icon_Blue : move_cert_input
        }') no-repeat`,
        // '#ff0566',
        cursor,
      }}
      onPointerDown={e => {
        const computedStyle = window.getComputedStyle(elementRef.current);

        const offsetX = e.clientX * inverseScaleFactor;
        const offsetY = e.clientY * inverseScaleFactor;

        const x = parseInt(computedStyle.left, 10);
        const y = parseInt(computedStyle.top, 10);

        const init = {
          offsetX,
          offsetY,
          x,
          y,
        };

        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);

        function onPointerMove(e) {
          const inverseScaleFactorClientX = e.clientX * inverseScaleFactor;
          const inverseScaleFactorClientY = e.clientY * inverseScaleFactor;

          const x = inverseScaleFactorClientX - init.offsetX;
          const y = inverseScaleFactorClientY - init.offsetY;

          const dragValueX = init.x + x;
          const dragValueY = init.y + y;

          elementRef.current.style.left = `${dragValueX}px`;
          elementRef.current.style.top = `${dragValueY}px`;
        }

        function onPointerUp(e) {
          const { left, top } = elementRef.current.style;
          onDragEnd({ left, top });

          window.removeEventListener('pointermove', onPointerMove);
          window.removeEventListener('pointerup', onPointerUp);
        }
      }}
    />
  );
};

const ResizeHandle = (props: any) => {
  const {
    id,
    elementRef,
    cursor = 'nwse-resize' || 'move',
    scaleFactor = 1,
    inverseScaleFactor = 1,
    onDrag = () => {},
    onDragEnd = () => {},
    isInput = false,
  } = props;

  if (!window.dev()) {
    return null;
  }

  return (
    <div
      id={`chameleon-text-resize-handle-${id}`}
      style={{
        position: 'absolute',
        right: 0,
        bottom: 0,
        width: handleSize,
        height: handleSize,
        ...(inverseScaleFactor > 1 && {
          transform: `scale(${inverseScaleFactor})`,
          transformOrigin: 'bottom right',
        }),
        background: `url('${
          !isInput ? Resize_Icon : resize_cert_input
        }') no-repeat`,
        // '#ff0566',
        cursor,
      }}
      onPointerDown={e => {
        const handle = e.currentTarget;

        const computedStyle = window.getComputedStyle(handle);

        const offsetX = e.clientX * inverseScaleFactor;
        const offsetY = e.clientY * inverseScaleFactor;

        const x = parseInt(computedStyle.left, 10);
        const y = parseInt(computedStyle.top, 10);

        const init = {
          offsetX,
          offsetY,
          x,
          y,
        };

        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);

        function onPointerMove(e) {
          const inverseScaleFactorClientX = e.clientX * inverseScaleFactor;
          const inverseScaleFactorClientY = e.clientY * inverseScaleFactor;

          const x = inverseScaleFactorClientX - init.offsetX;
          const y = inverseScaleFactorClientY - init.offsetY;

          const dragValueX = init.x + x;
          const dragValueY = init.y + y;

          if (dragValueX < handleSize * 2 || dragValueY < handleSize * 2) {
            return;
          }

          handle.style.left = `${dragValueX}px`;
          handle.style.top = `${dragValueY}px`;

          onDrag({
            left: `${dragValueX + handleSize}px`,
            top: `${dragValueY + handleSize}px`,
          });
        }

        function onPointerUp(e) {
          onDragEnd();

          window.removeEventListener('pointermove', onPointerMove);
          window.removeEventListener('pointerup', onPointerUp);
        }
      }}
    />
  );
};

export { DragHandle, ResizeHandle };
